import { useState, useEffect } from 'react';
import '../components/home/home.css';
import './AllCoursesPage.css';
import PageLayout from '../components/home/PageLayout';
import { Link, useNavigate } from 'react-router-dom';
import courseService from '../services/courseService.js';
// import Card from '../components/ui/Card.jsx'; // replaced by CourseHoverCard below
import { useAuthStore } from '../stores/authStore';

/* ── Static course data (commented out — replaced by API) ───── */
// const DEGREE_COURSES = [
//   {
//     img: '/images/Engineering-Mechanics-1_Somayya-Academy_Best-Engineering-Coaching-Classes-in-Pune_Best-Engineering-Classes-in-Pune-Kothrud-786x1024.jpg',
//     name: 'Engineering Mechanics',
//     year: 'First Year',
//     validity: '365',
//     desc: 'Covers fundamentals of statics, dynamics and kinematics for first-year engineering students.',
//   },
//   {
//     img: '/images/Strength Of materials.jpg',
//     name: 'Strength of Materials',
//     year: 'Second Year',
//     validity: '365',
//     desc: 'In-depth coverage of SOM concepts with solved examples and regular internal assessments.',
//   },
//   {
//     img: '/images/Structural analysis II.png',
//     name: 'Structural Analysis I',
//     year: 'Third Year',
//     validity: '365',
//     desc: 'Analysis of statically determinate and indeterminate structures, beams and frames.',
//   },
//   {
//     img: '/images/Structural-Analysis-I_Study-Material_Somayya-Academy-Pu_002.jpeg',
//     name: 'Structural Analysis II',
//     year: 'Third Year',
//     validity: '365',
//     desc: 'Advanced structural analysis — matrix methods, direct stiffness and moment distribution.',
//   },
//   {
//     img: '/images/Structural design I.jpg',
//     name: 'Structural Design I',
//     year: 'Final Year',
//     validity: '365',
//     desc: 'Design of RCC beams, columns, slabs and footings as per IS 456.',
//   },
//   {
//     img: '/images/Structual design II.jpg',
//     name: 'Structural Design II',
//     year: 'Final Year',
//     validity: '365',
//     desc: 'Steel structures, limit state design, connections and industrial structures.',
//   },
// ];

// const DIPLOMA_COURSES = [
//   {
//     img: '/images/Engg Mechanics.png',
//     name: 'Applied Mechanics',
//     year: 'Second Year Diploma',
//     validity: '365',
//     desc: 'Foundation subject for diploma students covering mechanics principles.',
//   },
//   {
//     img: '/images/ENgineering Graphics.jpg',
//     name: 'Engineering Graphics',
//     year: 'First Year Diploma',
//     validity: '365',
//     desc: 'Orthographic projection, sectional views and development of surfaces.',
//   },
// ];

// const AUTOCAD_COURSES = [
//   {
//     img: '/images/AutoCAD.jpg',
//     name: 'AutoCAD 2D',
//     year: 'Short Term Course',
//     validity: '180',
//     desc: '2D drafting, dimensioning, layers and printing with AutoCAD.',
//   },
//   {
//     img: '/images/autocad-a.jpg',
//     name: 'AutoCAD 3D',
//     year: 'Short Term Course',
//     validity: '180',
//     desc: '3D modelling, rendering and solid works with AutoCAD.',
//   },
// ];

/* ── Course card — now driven by API data ───────────────────── */
// onCardClick is injected by CourseSection so the whole card + button both navigate
// ── Old custom CourseCard (commented out — replaced by shared Card component below) ──
// function CourseCard({ course, onCardClick }) {
//   return (
//     <div
//       className="sa-course-card"
//       onClick={() => onCardClick && onCardClick(course)}
//       style={{ cursor: 'pointer' }}
//     >
//       <div className="sa-course-img">
//         <img
//           src={course.img}
//           alt={course.name}
//           onError={e => { e.target.src = '/images/Somayya-Academy-Best-Coaching-Classes-in-Pune.png'; }}
//         />
//       </div>
//       <div className="sa-course-body">
//         <h3 className="sa-course-title">{course.name}</h3>
//         <p className="sa-course-desc">{course.desc}</p>
//         <ul className="sa-course-meta">
//           <li><i className="fa fa-calendar" /> {course.year}</li>
//           <li><i className="fa fa-clock-o" /> {course.validity} Days Validity</li>
//         </ul>
//         {/* Price display — only shown when course comes from API */}
//         {course.offerPrice !== undefined && (
//           <div className="sa-course-price" style={{ marginBottom: 10 }}>
//             {course.offerPrice > 0 ? (
//               <>
//                 <span style={{ fontWeight: 700, color: '#1a237e' }}>
//                   ₹{course.offerPrice}
//                 </span>
//                 {course.originalPrice > 0 && course.originalPrice !== course.offerPrice && (
//                   <span style={{ textDecoration: 'line-through', color: '#888', marginLeft: 8, fontSize: 13 }}>
//                     ₹{course.originalPrice}
//                   </span>
//                 )}
//               </>
//             ) : (
//               <span style={{ fontWeight: 700, color: '#1a237e' }}>Free</span>
//             )}
//           </div>
//         )}
//         {/* View Course button — navigates to /course/:id which fetches topics via getAll?courseId */}
//         <button
//           className="sa-btn sa-btn-accent"
//           onClick={e => { e.stopPropagation(); onCardClick && onCardClick(course); }}
//         >
//           View Course
//         </button>
//         {/* Old static "Enroll Now" link (commented out — replaced by click navigation above) */}
//         {/* <Link to="/login" className="sa-btn sa-btn-accent">Enroll Now</Link> */}
//       </div>
//     </div>
//   );
// }

/* ── Static CourseSection helper (unchanged) ─────────────────── */
// ── Old CourseSection using custom CourseCard (commented out — replaced below) ──
// function CourseSection({ title, courses, onCardClick }) {
//   return (
//     <div className="sa-courses-section">
//       <h2 className="sa-courses-section-title">{title}</h2>
//       <div className="sa-courses-grid">
//         {courses.map(c => <CourseCard key={c.id || c.name} course={c} onCardClick={onCardClick} />)}
//       </div>
//     </div>
//   );
// }

/* ── CourseHoverCard — popup floats above card on hover ── */
function CourseHoverCard({ course, onCardClick }) {
  const hasDiscount =
    course.originalPrice &&
    course.originalPrice > 0 &&
    course.originalPrice !== course.offerPrice;

  const highlights = [
    '✓ Structured video lectures',
    '✓ Practice problems & solutions',
    '✓ Expert faculty guidance',
  ];

  return (
    <div className="chc-wrapper">
      {/* ── Base card — greys out on hover ── */}
      <div className="chc-card" onClick={() => onCardClick && onCardClick(course)}>
        <div className="chc-image-wrap">
          <img
            src={course.img}
            alt={course.name}
            className="chc-image"
            onError={e => {
              e.target.src = '/images/Somayya-Academy-Best-Coaching-Classes-in-Pune.png';
            }}
          />
          {hasDiscount && (
            <span className="chc-badge">
              {Math.round(((course.originalPrice - course.offerPrice) / course.originalPrice) * 100)}% OFF
            </span>
          )}
        </div>
        <div className="chc-body">
          <h3 className="chc-title">{course.name}</h3>
          <div className="chc-meta">
            <div className="chc-price-row">
              <span className="chc-offer-price">
                {course.offerPrice > 0 ? `₹${course.offerPrice}` : 'Free'}
              </span>
              {hasDiscount && (
                <span className="chc-original-price">₹{course.originalPrice}</span>
              )}
            </div>
            <span className="chc-duration">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" />
              </svg>
              4 months
            </span>
          </div>
        </div>
      </div>

      {/* ── Popup — course image and details ── */}
      <div className="chc-popup">
        <div className="chc-popup-img">
          <img
            src={course.img}
            alt={course.name}
            onError={e => {
              e.target.src = '/images/Somayya-Academy-Best-Coaching-Classes-in-Pune.png';
            }}
          />
          {hasDiscount && (
            <span className="chc-popup-img-badge">
              {Math.round(((course.originalPrice - course.offerPrice) / course.originalPrice) * 100)}% OFF
            </span>
          )}
        </div>
        <div className="chc-popup-info">
          <h4 className="chc-popup-title">{course.name}</h4>

          {course.desc && (
            <p className="chc-popup-desc">
              {course.desc.length > 100 ? course.desc.slice(0, 97) + '…' : course.desc}
            </p>
          )}

          <div className="chc-popup-chips">
            <span className="chc-popup-chip">
              <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
              </svg>
              4 months
            </span>
            <span className="chc-popup-chip">
              <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/>
              </svg>
              Expert faculty
            </span>
          </div>

          <ul className="chc-popup-highlights">
            {highlights.map((h, i) => <li key={i}>{h}</li>)}
          </ul>

          <div className="chc-popup-footer">
            <div className="chc-popup-price-col">
              <span className="chc-popup-offer-price">
                {course.offerPrice > 0 ? `₹${course.offerPrice}` : 'Free'}
              </span>
              {hasDiscount && (
                <span className="chc-popup-original-price">₹{course.originalPrice}</span>
              )}
            </div>
            <button
              className="chc-popup-btn"
              onClick={e => { e.stopPropagation(); onCardClick && onCardClick(course); }}
            >
              Enroll Now →
            </button>
          </div>
        </div>

      </div>
    </div>
  );
}

/* ── CourseSection — grid of CourseHoverCards ── */
function CourseSection({ title, courses, onCardClick }) {
  return (
    <div className="sa-courses-section">
      <h2 className="sa-courses-section-title">{title}</h2>
      <div className="chc-grid">
        {courses.map(c => (
          <CourseHoverCard
            key={c.id || c.name}
            course={c}
            onCardClick={onCardClick}
          />
        ))}
      </div>
    </div>
  );
}

/* ── Static section render (commented out — replaced by API) ── */
// function StaticSections() {
//   return (
//     <>
//       <CourseSection title="Engineering Degree" courses={DEGREE_COURSES} />
//       <CourseSection title="Engineering Diploma" courses={DIPLOMA_COURSES} />
//       <CourseSection title="AutoCAD" courses={AUTOCAD_COURSES} />
//     </>
//   );
// }

/* ── Map raw API response to the shape CourseCard expects ───── */
function mapApiCourse(apiCourse) {
  return {
    // API fields
    id: apiCourse.id,
    name: apiCourse.title,
    desc: apiCourse.description,
    img: apiCourse.displayPicture,
    originalPrice: apiCourse.originalPrice,
    offerPrice: apiCourse.offerPrice,
    isPurchase: apiCourse.isPurchase,
    status: apiCourse.status,
    // Static defaults (not returned by this endpoint)
    year: '',        // not provided by /courses/getAll
    validity: '365', // default; update if API adds a validity field later
  };
}

/* ── Page component ─────────────────────────────────────────── */
export default function AllCoursesPage() {
  const navigate = useNavigate();
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const [courses, setCourses] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  /* Navigate to CourseDetailsPage — same pattern as MyCoursesPage.handleCourseClick
     CourseDetailsPage reads courseId from useParams and internally calls:
       GET /courses/getAll?courseId=<id>
       GET /topics/getAll?courseId=<id>&status=ACTIVE
     If the user is not logged in, redirect to /login first.
     After login, React Router will land them back here and they can click again.
  */
  const handleCourseClick = (course) => {
    // ── Auth guard: send unauthenticated users to login ──────────
    if (!isAuthenticated) {
      navigate('/login');
      return;
    }
    // ── Authenticated: proceed to course details ─────────────────
    const courseId = course.id;
    console.log('Navigating to course:', courseId);
    navigate(`/course/${courseId}`, {
      state: {
        from: 'all-courses', // tells CourseDetailsPage to send "Back" to /all-courses
        course: {
          ...course,
          // remap back to API field names CourseDetailsPage expects
          id: courseId,
          title: course.name,
          description: course.desc,
          displayPicture: course.img,
          offerPrice: course.offerPrice,
          originalPrice: course.originalPrice,
          isPurchase: course.isPurchase,
          status: course.status,
        },
        isPurchased: course.isPurchase || false,
      }
    });
  };

  /* Fetch all active courses — same pattern used in MyCoursesPage */
  const fetchCourses = async () => {
    try {
      setIsLoading(true);
      setError(null);

      const result = await courseService.getCourses(); // GET /courses/getAll?status=ACTIVE
      console.log('All courses API response:', result);

      if (result && result.success) {
        const mapped = (result.data || []).map(mapApiCourse);
        setCourses(mapped);
      } else {
        console.error('Failed to fetch courses:', result?.error);
        setError(result?.error || 'Failed to load courses. Please try again later.');
      }
    } catch (err) {
      console.error('Error fetching courses:', err);
      setError('Failed to load courses. Please try again later.');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchCourses();
  }, []);

  /* ── Loading state ── */
  if (isLoading) {
    return (
      <PageLayout title="All Packages" breadcrumb="Courses">
        <div className="sa-container" style={{ padding: '48px 15px', textAlign: 'center' }}>
          <p style={{ fontSize: 16, color: '#555' }}>Loading courses…</p>
        </div>
      </PageLayout>
    );
  }

  /* ── Error state ── */
  if (error) {
    return (
      <PageLayout title="All Packages" breadcrumb="Courses">
        <div className="sa-container" style={{ padding: '48px 15px', textAlign: 'center' }}>
          <p style={{ color: '#c0392b', fontSize: 16 }}>{error}</p>
          <button
            onClick={fetchCourses}
            className="sa-btn sa-btn-primary"
            style={{ marginTop: 16 }}
          >
            Retry
          </button>
        </div>
      </PageLayout>
    );
  }

  return (
    <PageLayout title="All Packages" breadcrumb="Courses">
      <div className="sa-container" style={{ padding: '48px 15px' }}>

        {/* ── API-driven courses ─────────────────────────────────── */}
        {courses.length > 0 ? (
          <CourseSection title="All Courses" courses={courses} onCardClick={handleCourseClick} />
        ) : (
          <p style={{ textAlign: 'center', color: '#555', fontSize: 16 }}>
            No courses available at the moment.
          </p>
        )}

        {/* ── Static sections (commented out — replaced by API) ──
        <CourseSection title="Engineering Degree" courses={DEGREE_COURSES} />
        <CourseSection title="Engineering Diploma" courses={DIPLOMA_COURSES} />
        <CourseSection title="AutoCAD" courses={AUTOCAD_COURSES} />
        ── end static sections ── */}

        {/* Login CTA */}
        {/* <div className="sa-courses-cta">
          <h3>Want to purchase a course?</h3>
          <p>Login or register to browse all available packages, pricing and validity details.</p>
          <Link to="/login" className="sa-btn sa-btn-primary" style={{ marginRight: 12 }}>Login</Link>
          <Link to="/login" className="sa-btn sa-btn-accent">Register</Link>
        </div> */}

      </div>
    </PageLayout>
  );
}
